import { Component, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-backward-forward',
  templateUrl: 'backward-forward.component.html',
  styleUrls: ['backward-forward.component.scss']
})
export class BackwardForwardComponent implements OnDestroy {

  constructor(
    private notificationService: NotificationService,
  ) {
  }

  private _forwardError: string;
  @Input() set forwardError(value: string) {
    this._forwardError = value;
    this.notificationService.show(BackwardForwardComponent.name, value);
  }

  @Output() backwardClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() forwardClick: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  hideBack: boolean;

  @Input()
  hideNext: boolean;

  @Input()
  forwardEnabled = true;

  @Input()
  backTitle: string;

  @Input()
  nextTitle: string;

  @Input()
  forwardCssClass = '';

  onBackwardClick() {
    this.backwardClick.emit();
  }

  onForwardClick() {
    if (!this.forwardError) {
      this.forwardClick.emit();
    }
  }

  get forwardError() {
    return this._forwardError;
  }

  get cssClassForwardButton() {
    const disabled = this.forwardError || !this.forwardEnabled ? ' disabled' : '';
    const cssClasses = `button button-right button-black float-right${disabled}${this.forwardCssClass}`;
    return cssClasses;
  }

  ngOnDestroy(): void {
    this.notificationService.hide(BackwardForwardComponent.name);
  }

}
